import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Creative AWS cloud solutions <br /> to elevate your business
          </>
        }
        description={
          <>
            Scale your product with the power of <b>AWS Cloud</b>
          </>
        }
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="orange-purple"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            Rumble Fish is an AWS cloud solutions company with vast knowledge of
            the latest cloud trends and tools.
            <br />
            We’ve worked with global customers to help them bring their
            businesses to the next level. Join them!
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
